<template>
  <div style="position: relative;">
    <Tab class="tab" ref="Tab" :tabIdx="tabIdx" :data="tabData" @onToggleTab="onToggleTab">
      <template #default>
        <el-row>
          <div class="box">
            <div class="wrap">
              <div class="item" v-for="(v, i) in dataList" :key="'ditem' + i">
                <div class="label" :class="v.className">{{ v.label }}</div>
                <div class="value">{{ v.value }}</div>
              </div>
            </div>
          </div>
          <!-- 第二列 -->
          <div class="box" style="margin: 0 1.5%;">
            <div class="totData">
              <div class="Dscreen">
                <div class="item" v-for="(v, i) in dataArr1" :key="'itema' + i">
                  <div class="tit">{{ v.label }}</div>
                  <div class="ps">{{ v.value }}</div>
                </div>
              </div>

              <div class="datalist">
                <div class="item" v-for="(v, i) in dataList1" :key="'v2item' + i">
                  <div class="top">
                    <div class="l">{{ v.license }}</div>

                    <div class="r">
                      <div class="itm">
                        当前差额：{{ v.diff }}
                      </div>

                      <div class="itm">
                        达成率：{{ v.cop_rate }}%
                      </div>
                    </div>
                  </div>

                  <div class="row1">
                    <div class="block" :style="{ width: (v.val / v.mb) * 100 + '%' }">
                      <div class="num">本月运费：{{ v.val }}</div>
                    </div>
                  </div>

                  <div class="row2">
                    <div class="block" :style="{ width: (v.mb / v.mb) * 100 + '%' }">
                      <div class="num">目标运费：{{ v.mb }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 第三列 -->
          <div class="box">
            <div class="totData type2">
              <div class="Dscreen">
                <div class="item" v-for="(v, i) in dataArr2" :key="'itemb' + i">
                  <div class="tit">{{ v.label }}</div>
                  <div class="ps">{{ v.value }}</div>
                </div>
              </div>

              <div class="datalist">
                <div class="item" v-for="(v, i) in dataList2" :key="'v2item' + i">
                  <div class="top">
                    <div class="l">{{ v.license }}</div>

                    <div class="r">
                      <div class="itm">
                        当前差额：{{ v.diff }}
                      </div>

                      <div class="itm">
                        达成率：{{ v.cop_rate }}%
                      </div>
                    </div>
                  </div>

                  <div class="row1">
                    <div class="block" :style="{ width: (v.val / v.mb) * 100 + '%' }">
                      <div class="num">本月净利润：{{ v.val }}</div>
                    </div>
                  </div>

                  <div class="row2">
                    <div class="block" :style="{ width: (v.mb / v.mb) * 100 + '%' }">
                      <div class="num">目标净利润：{{ v.mb }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-row>
      </template>
    </Tab>

    <el-button class="exportBtn" type="primary" size="small" :loading="btnloading" @click="generatProfit">
      数据生成
    </el-button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      baseUrl: 'cartarget',
      tabIdx: 0,
      tabData: [
        { name: '全部', value: 0 },
      ],
      dataList: [],
      dataArr1: [],
      dataList1: [],
      dataArr2: [],
      dataList2: [],
      checkedIds: [],
      btnloading: false,
    };
  },
  computed: {
    ...mapState([
      'user',
    ]),
    CURR_MONTH() {
      const date = new Date()
      const y = date.getFullYear()
      let m = date.getMonth() + 1
      m > 9 ? null : m = '0' + m
      // console.log(y, m)
      return `${y}-${m}`
    },
  },
  methods: {
    generatProfit() {
      if (!this.checkedIds.length) {
        this.$message({
          type: 'error',
          message: '暂无车辆',
        });
        return;
      }
      this.btnloading = true
      let url = `money/addedu`;
      const params = {
        userid: this.user.id,
        month: this.CURR_MONTH,
        car_id: this.checkedIds,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getPageData()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.btnloading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
        this.btnloading = false
      })
    },
    updateMonth() {
      let url = `money/updatemonth`;
      const params = {
        // userid: this.user.id,
      }
      this.post(url, params, (res) => {
        const { msg, car } = res
        // console.log(res)
        if (msg === 'success' && car && car.length) {
          this.checkedIds = car.map(v => v.id)
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onToggleTab({ index }) {
      // this.tabIdx = index;
      console.log(index)
      this.getPageData({ fleet: this.tabData[index].value });
    },
    getTabData() {
      if (this.loading) {
        return
      }
      this.loading = true
      let url = `base/getmyfleet`;
      const params = {
        // userid: this.user.id,
      }
      this.post(url, params, (res) => {
        const { msg, team } = res
        if (msg === 'success' && team) {
          // console.log(res)
          team.map(v => {
            const obj = {
              name: v.nickname,
              value: v.id,
            }
            this.tabData.push(obj)
          })
          this.$nextTick(() => {
            this.$refs.Tab.refresh()
          })
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
      this.loading = false
    },
    getPageData(params = {}) {
      if (this.loading) {
        return
      }
      // 加载中
      this.loading = true
      // 清空数据
      this.dataList = []
      this.dataList1 = []
      this.dataList2 = []
      this.dataArr1 = []
      this.dataArr2 = []
      // 请求数据
      let url = `${this.baseUrl}/index`;
      // console.log(url, params)
      this.post(url, params, (res) => {
        const { msg, summary, detailed } = res
        if (msg === 'success' && summary) {
          const o = { ...summary }
          const a = []
          a.push({
            label: '运单数量',
            value: o.order_num,
            className: 't0',
          })
          a.push({
            label: '车辆数量',
            value: o.car_num,
            className: 't0',
          })
          a.push({
            label: '营业成本',
            value: o.cost,
            className: 't1',
          })
          a.push({
            label: '司机工资',
            value: o.driver_salary,
          })
          a.push({
            label: '押运员工资',
            value: o.escort_salary,
          })
          a.push({
            label: '出车费用',
            value: o.daypay,
          })
          a.push({
            label: '固定费用',
            value: o.fixedpay,
          })
          a.push({
            label: '维保费用',
            value: o.repair,
          })
          a.push({
            label: '附加费用',
            value: o.additional_fees,
          })
          a.push({
            label: '亏吨金额',
            value: o.kuitotal,
          })
          a.push({
            label: '利润奖金',
            value: o.eswage,
          })
          a.push({
            label: '运单补差',
            value: o.compen,
          })
          this.dataList.push(...a)

          if (detailed) {
            const f = { ...(detailed.freight_summary || {}) }
            const b = []
            b.push({
              label: '本月运费额',
              value: f.freight,
            })
            b.push({
              label: '目标运费额',
              value: f.mb_freight,
            })
            b.push({
              label: '当前差额',
              value: f.freight_difference,
            })
            b.push({
              label: '目标达成率',
              value: f.completion_rate + '%',
            })
            this.dataArr1.push(...b)

            const p = { ...(detailed.profit_summary || {}) }
            const c = []
            c.push({
              label: '本月净利润',
              value: p.profit,
            })
            c.push({
              label: '目标净利润',
              value: p.mb_profit,
            })
            c.push({
              label: '当前差额',
              value: p.profit_difference,
            })
            c.push({
              label: '目标达成率',
              value: p.completion_rate + '%',
            })
            this.dataArr2.push(...c)

            const li = detailed.list_data
            if (li && li.length) {
              const mb_freight = []
              const mb_profit = []
              li.map(v => {
                // if (v.carstatus == '在用') {
                // console.log(v)
                // 运费
                const o = {
                  license: v.license,
                }
                if (v.carstatus == '停用') {
                  o['license'] = `${v.license}(${v.carstatus})`
                }
                const fd = v.freight_detail
                if (fd) {
                  // console.log(v.freight_detail)
                  if (fd.mb_freight) {
                    mb_freight.push(Number(fd.mb_freight))
                  }
                  if (fd.freight) {
                    mb_freight.push(Number(fd.freight))
                  }
                  o['diff'] = fd['freight_difference']
                  o['mb'] = fd['mb_freight']
                  o['cop_rate'] = fd['completion_rate']
                  o['val'] = fd['freight']
                }
                this.dataList1.push(o)

                // 净利润
                const o2 = {
                  license: v.license,
                }
                if (v.carstatus == '停用') {
                  o2['license'] = `${v.license}(${v.carstatus})`
                }
                const pd = v.profit_detail
                if (pd) {
                  // console.log(v.profit_detail)
                  if (pd.mb_profit) {
                    mb_profit.push(Number(pd.mb_profit))
                  }
                  if (pd.profit) {
                    mb_profit.push(Number(pd.profit))
                  }
                  o2['diff'] = pd['profit_difference']
                  o2['mb'] = pd['mb_profit']
                  o2['cop_rate'] = pd['completion_rate']
                  o2['val'] = pd['profit']
                }
                this.dataList2.push(o2)
                // }
              })
              // console.log(mb_freight)
              const max = Math.max(...mb_freight)
              // console.log(max)
              this.dataList1.map(v => {
                v.max = max
              })
              const maxp = Math.max(...mb_profit)
              // console.log(maxp)
              this.dataList2.map(v => {
                v.max = maxp
              })
              this.dataList1.sort((a, b) => b.cop_rate - a.cop_rate)
              this.dataList2.sort((a, b) => b.cop_rate - a.cop_rate)
              // console.log([...this.dataList1])
              // console.log([...this.dataList2])
            }
          }

        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
      this.loading = false
    },
  },
  mounted() {
    this.getTabData()
    this.getPageData()
    this.updateMonth()
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 32%;
  float: left;

  .wrap {
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.04);
    border-radius: 10px;
    padding: 20px 20px 5px 20px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .item {
      background: #F9F9F9;
      border-radius: 5px;
      padding: 16px 0 15px 0;
      width: 48%;
      margin-bottom: 15px;

      .label {
        height: 22px;
        line-height: 22px;
        position: relative;
        padding-left: 20px;
        font-size: 15px;
        color: #303133;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 5px;
          height: 100%;
          background: #3E82FE;
        }

        &.t0::before {
          background: #67C23A;
        }

        &.t1::before {
          background: #E6A23C;
        }
      }

      .value {
        font-size: 20px;
        color: #303133;
        padding-left: 20px;
        margin-top: 14px;
      }
    }
  }
}

.todpro {
  height: auto;
  overflow: hidden;
  margin: 0 auto 20px;
  border-radius: 10px;
  background: linear-gradient(270deg, #00CF9E 0%, #2691FF 100%);

  .item {
    float: left;
    width: 32%;
    height: auto;
    overflow: hidden;
    margin: 0 0 0 1%;

    .info {
      height: auto;
      overflow: hidden;
      margin: 0 auto;
      border-right: 1px solid rgba(255, 255, 255, 0.23);

      h3 {
        height: auto;
        overflow: hidden;
        margin: 20px auto;
        text-align: center;
        line-height: 19px;
        font-size: 14px;
        color: #fff;
        opacity: 0.8;
      }

      p {
        height: auto;
        overflow: hidden;
        margin: 0 auto 20px;
        text-align: center;
        line-height: 29px;
        font-size: 22px;
        color: #fff;
      }
    }

    &:first-child {
      .info {
        h3 {
          opacity: 1;
        }
      }
    }
  }
}

.totData {
  height: auto;
  overflow: hidden;
  margin: 0 auto;
  padding: 20px 20px 0;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 4%);
  background: #fff;
  font-family: Microsoft YaHei, Microsoft YaHei;

  &.type2 {

    .Dscreen,
    .datalist .item .row1 .block {
      background: #67C23A;
    }
  }

  .Dscreen {
    height: 95px;
    overflow: hidden;
    margin: 0 auto 20px;
    border-radius: 10px;
    background: #3E82FE;

    .item {
      float: left;
      width: 25%;
      height: 95px;
      overflow: hidden;
      color: #FFFFFF;
      text-align: center;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 27px;
        width: 1px;
        height: 42px;
        background: #FFFFFF;
        opacity: 0.15;
      }

      &:last-child::after {
        display: none;
      }

      .tit {
        height: 19px;
        line-height: 19px;
        overflow: hidden;
        margin: 20px 0 15px 0;
        font-size: 14px;
        font-weight: 400;
      }

      .ps {
        height: 21px;
        line-height: 21px;
        overflow: hidden;
        margin: 0 0 20px 0;
        font-size: 16px;
      }
    }
  }

  .datalist {
    .item {
      background: #F9F9F9;
      border-radius: 5px;
      padding: 10px 15px;
      box-sizing: border-box;
      margin-bottom: 15px;

      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .l {
          font-size: 15px;
          color: #303133;
        }

        .r {
          font-size: 12px;
          color: #909399;
          text-align: right;
          display: flex;

          .itm {
            margin-left: 15px;
          }
        }
      }

      .row1 {
        display: flex;
        align-items: center;
        width: 70%;
        margin-top: 21px;

        .block {
          min-width: 4px;
          height: 20px;
          background: #2691FF;
          box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.1);
          border-radius: 3px;
          position: relative;

          .num {
            font-size: 12px;
            color: #606266;
            position: absolute;
            width: 130px;
            right: -135px;
          }
        }

      }

      .row2 {
        display: flex;
        align-items: center;
        width: 70%;
        margin-top: 10px;

        .block {
          height: 17px;
          background: #DDE2EE;
          box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.1);
          border-radius: 3px;
          position: relative;

          .num {
            font-size: 12px;
            color: #606266;
            position: absolute;
            width: 130px;
            right: -135px;
          }
        }

      }
    }
  }
}

.dialog /deep/ .el-dialog {
  width: 40%;
  margin-top: 20px !important;
  margin-bottom: auto;
}

.tab {
  margin: 1px;

  &.tab-page {
    /deep/.el-tabs__header {
      padding: 0;
      margin-bottom: 30px;

      .el-tabs__nav-wrap::after {
        width: 100%;
      }
    }
  }

}

.exportBtn {
  position: absolute !important;
  top: 0px;
  right: 20px;
  // width: 78px;
  // height: 29px;
  // background: url(../assets/img/daochu.png) no-repeat right center;
  // background-size: 78px 29px;
}
</style>
